import { Component, Input, OnInit } from '@angular/core';
import { placeholderTypes } from '../../../../../constants/placeholder-types.constants';
import { ITaxation } from '../../../../../core/interfaces/taxation';
import { IOffer } from '../../../../../core/interfaces/offer';

@Component({
  selector: 'app-booking-total-info',
  templateUrl: './booking-total-info.component.html',
  styleUrls: ['./booking-total-info.component.scss'],
  standalone: false
})
export class BookingTotalInfoComponent implements OnInit {
  placeholderTypes = placeholderTypes;

  @Input() classList: string;
  @Input() dataFetched: boolean;
  @Input() confirmationDataLoaded: boolean;
  @Input() daysCount: number;
  @Input() confirmationTotal: number;
  @Input() currency: string;
  @Input() applicableCosts: ITaxation;
  @Input() ratePlan: IOffer;
  @Input() isOfferExist: boolean;
  @Input() isExtension: boolean;

  constructor() {}

  ngOnInit() {}
}
